import gsap, { Power1, Power2, Power4 } from 'gsap';
import { Shffl } from '../_app/cuchillo/components/Shffl';
import { Basics, hasSlowConnection, isSmartphone, isTouch } from '../_app/cuchillo/core/Basics';
import { GetBy } from '../_app/cuchillo/core/Element';

import Keyboard from '../_app/cuchillo/core/Keyboard';
import { ControllerPage } from '../_app/cuchillo/pages/ControllerPage';

import BGVideo from '../layout/BGVideo';
import Default from './Default';
import { Metrics } from '../_app/cuchillo/core/Metrics';
import VisorVideos from '../layout/VisorVideos';
import Header from '../layout/Header';
import InfiniteScroll__HomeItem from '../scroll/InfiniteScroll__HomeItem';
import InfiniteScroll from '../_app/cuchillo/scroll/InfiniteScroll';
import { EventDispatcher } from 'three';
import { Interaction } from '../_app/cuchillo/core/Interaction';

export default class Home extends Default {
  static idTimer;
  static isVideoLoaded = true;
  static positionCircle = {x:0,y:0,opacity:0};
  static absSpeed = 0;

  visor;
  particlesHome;
  projectsHome = [];
  actual = 0;
  isMouseEnabled = false;
  _zoneHover = {
    offset:0,
    width:0
  };
  _isHover = false;
  _isScroll = false;
  _isOpen = false;
  _calls = {
    click: (e) => { this._click(e); },
  }
  
//==================================================================================================================
//          CONSTRUCTOR
//==================================================================================================================

  constructor() {
    super();
    this.visor = new Home__Visor(GetBy.selector("[data-visor]")[0]);
    this.holder = GetBy.class('__holder', this.container)[0];
    this.scroller = new InfiniteScroll(isTouch? InfiniteScroll.AXIS_Y : InfiniteScroll.AXIS_Y, {
        domResize: this.container,
        appendContainer: this.holder,
        container: this.holder,
        multiplicator: 1,
        minSpeed: Math.round(Metrics.HEIGHT * .003),
        inverted: false,
        delayCheck: isSmartphone? 3000 : 400,
        gap: 0,
        itemClass: InfiniteScroll__HomeItem,
        hasVirtuaScroll: true
    });

    this.visor.visor.scale = 1;
    this.scroller.onStartScroll = () => this._focusOn(true);
    this.scroller.onEndScroll = () => this._focusOff(true);

    this.scroller._items.map((item, i) => {
      item.setHover = () => { this.visor.change(i, item.data);}
      item.callbackShow = () => { this.visor.change(i, item.data);}
      item.getMedia = (i) => { return this.visor.visor.videos[i];}
    });
  }

  _focusOn(__isScroll = false, __isHover = false) {
    if(__isScroll) this._isScroll = true;
    if(__isHover) this._isHover = true;
    if(this._isOpen) return;

    this._isOpen = true;
    this.scroller.minSpeed = 0;

    gsap.killTweensOf(Home.positionCircle);
    gsap.killTweensOf(this.visor.visor);
    gsap.killTweensOf(this.holder,);
    this.visor.hasFocus = true;
    this.visor.visor.hasFocus = true;
    gsap.to(this.holder, {opacity:0, duration:.2, ease:Power2.easeIn});
    gsap.to(this.visor.container, {opacity:0, duration:.2, ease:Power2.easeIn});
    gsap.to(this.visor.visor, {blur:100, scale:2, overlay:.25, duration:.2, ease:Power2.easeIn});
    gsap.to(Home.positionCircle, {opacity:1, duration:.4, delay:.2, ease:Power2.easeOut});
    gsap.to(Home.positionCircle, {y:0,duration:.8, ease:Power4.easeOut});
    gsap.to(Home.positionCircle, {x:0,duration:1, ease:Power4.easeOut});
    
    //EventDispatcher.dispatchEvent("FOCUS_ON");
  }

  _focusOff(__isScroll = false, __isHover = false) {
    if(__isScroll) this._isScroll = false;
    if(__isHover) this._isHover = false;
    if(!this._isOpen || this._isHover || this._isScroll) return;

    this._isOpen = false;
    this.scroller.minSpeed = Math.round(Metrics.HEIGHT * .003);

    gsap.killTweensOf(Home.positionCircle);
    gsap.killTweensOf(this.visor.visor);
    gsap.killTweensOf(this.holder,);
    this.visor.hasFocus = false;
    this.visor.visor.hasFocus = false;
    gsap.to(this.holder, {opacity:1, duration:.2, delay: .2, ease:Power2.easeIn});
    gsap.to(this.visor.container, {opacity:1, duration:.2, delay: .2, ease:Power2.easeIn});
    gsap.to(this.visor.visor, {blur:0, scale:1, overlay:.14, duration:.2, delay:.2, ease:Power2.easeIn});
    gsap.to(Home.positionCircle, {opacity:0, duration:.1, delay:.2, ease:Power2.easeIn});
    gsap.to(Home.positionCircle, {y:Metrics.HEIGHT,duration:.4, ease:Power2.easeIn});
    gsap.to(Home.positionCircle, {x:-Metrics.WIDTH,duration:.5, ease:Power2.easeIn});
    //EventDispatcher.dispatchEvent("FOCUS_OFF");
  }


  beforeShow() {
    Header.openHeader();
    this.scroller.start();
    this.scroller.show();
    this.scroller.goto(10, false);
    Keyboard.mountPage(this.id);
  }

  afterShow() {
    this._isActive = true; 
    
    setTimeout(()=> {
      this.isMouseEnabled = true;
    }, 1000);
  }

  beforeHide() {
    clearTimeout(Home.idTimer);
    
    if(this.scroller) this.scroller.hide();
    this.visor.hide();
    super.beforeHide();
  }

  afterHide() {
    super.afterHide();
  }

  //RESIZE
  resize() {
    super.resize();
    this._zoneHover.offset = Metrics.WIDTH * .05;
    this._zoneHover.width = Metrics.WIDTH * .5;
    Home.positionCircle.x = -Metrics.WIDTH;
    Home.positionCircle.y = Metrics.HEIGHT;
    if(this.scroller) this.scroller.resize();
  }
   //LOOP
  loop() {
    this.scroller.loop(true);
    Home.absSpeed = Math.abs(this.scroller.speed);

    if(isTouch) return;
    
    if(Interaction.positions.mouse.x < this._zoneHover.offset + this._zoneHover.width * Interaction.positions.mouse.y/Metrics.HEIGHT && this.isMouseEnabled)  {
      this._focusOn(false, true);
    } else {
      this._focusOff(false, true);
    }
  }

  dispose() {
    super.dispose();
    this.visor.dispose();
  }
}

class Home__Visor {
  isShow = false;
  container = GetBy.selector("[data-visor]")[0];
  dom = {};  
  actual = null;
  data = null;
  visor;
  hasFocus = false;

  constructor(__dom) {
    this.visor = new VisorVideos(GetBy.class("__visor_videos")[0]);
    this.container = __dom;
    this.init();
  }

  init() {
    this.dom = {
      title: GetBy.selector("[data-project-title]", this.container)[0],
      director: GetBy.selector("[data-project-director]", this.container)[0],
      client: GetBy.selector("[data-project-client]", this.container)[0],
    }
  }

  change(next, data) {
    if(this.actual == next) return;

    this.actual = next;
    this.data = data;

    this.hide();
    this.visor.change(next);
  }

  changeValues() {
    gsap.killTweensOf(this.container);

    this.dom.title.textContent = this.data.title;
    this.dom.director.textContent = this.data.director;
    this.dom.client.textContent = this.data.client;
    this.container.setAttribute("href", this.data.href);    

    if(!this.hasFocus) {
      gsap.killTweensOf(this.container);
      gsap.set(this.container,{y:0});
      gsap.to(this.container,{y:0, duration:.2});
      gsap.to(this.container,{alpha:1, duration:.1, delay: .1, ease:Power2.easeOut});
    } else {
      gsap.set(this.container,{y:0,opacity:0});
    }
  }

  hide() {
    gsap.killTweensOf(this.container);

    if(this.hasFocus) {
      gsap.set(this.container,{y:0,opacity:0});
      this.changeValues();
    } else {
      gsap.to(this.container,{y:-Metrics.HEIGHT * .05, duration:1, ease:Power2.easeIn});
      gsap.to(this.container,{alpha:0, duration:.2, ease:Power2.easeOut, onComplete:() => {
        this.changeValues();
      }});
    }
  }

  dispose() {
    this.visor.dispose();
  }
}

ControllerPage._addPage("page-home", Home)
